/** @jsx jsx */

import { useState } from 'react';

import { Spacing } from '@zapier/theme';
import {
  FloatingBox,
  Icon,
  LegacyButton,
  Menu,
  MenuItem,
  Spacer,
} from '@zapier/design-system';
import { css, jsx } from '@emotion/core';

const Styles = {
  root: css`
    position: relative;
  `,
  button: css`
    align-items: center;
    display: flex;
  `,
};

type Props = {
  choices: Array<{ label: string; value: string }>;
  isDisabled: boolean;
  onChoose: (option: { value: string }) => void;
  text: string;
};

const AddInputButton = (props: Props) => {
  const { isDisabled, choices, text, onChoose } = props;

  const [isOpen, setIsOpen] = useState(false);

  return (
    <div css={Styles.root}>
      <LegacyButton
        aria-label="Choose the type of input field to add to your Action."
        disabled={isDisabled}
        onClick={() => setIsOpen(!isOpen)}
      >
        <span css={Styles.button}>
          {text}
          <Spacer width={Spacing.unit} />
          <Icon name="arrowSmallDown" size={30} />
        </span>
      </LegacyButton>
      {isOpen && (
        <FloatingBox onClickOutside={() => setIsOpen(false)}>
          <Menu aria-label="List of input types">
            {choices.map(choice => (
              <MenuItem key={choice.value} onClick={() => onChoose(choice)}>
                {choice.label}
              </MenuItem>
            ))}
          </Menu>
        </FloatingBox>
      )}
    </div>
  );
};

AddInputButton.defaultProps = {
  text: 'Add',
};

export default AddInputButton;
